export const styles = (theme) => ({
    ...theme.softpro.tableColumns,
});
